import { EntityLink, type EntityKind } from '@/shared/components/entity-link';

/**
 * O par `module/ownerType` que tem página no admin-dashboard, e qual. O
 * `ownerDeepLink` do back (`${module}/${ownerType}/${ownerId}`) não é rota do
 * front; a tradução mora aqui. `question` e `official_comment` gravam o id do
 * `ContentItem`, que a tela de item abre qualquer que seja o tipo.
 *
 * Fica de fora, por não ter página (Decisão 4 do épico files-admin): `pipefy`,
 * `forms`, o alerta operacional do sales (só tem lista) e o anexo pendente
 * (sem dono).
 */
const OWNER_TARGETS: Record<string, EntityKind> = {
  'sales/sales_manual_settlement': 'transaction',
  'sales/sales_transaction_invalidation': 'transaction',
  'content/question': 'contentItem',
  'content/official_comment': 'contentItem',
};

export function ownerTarget(
  module: string,
  ownerType: string,
): EntityKind | null {
  return OWNER_TARGETS[`${module}/${ownerType}`] ?? null;
}

export function OwnerLink({
  module,
  ownerType,
  ownerId,
}: {
  module: string;
  ownerType: string;
  ownerId: string | null;
}) {
  if (!ownerId) {
    return (
      <span className="text-(--color-text-secondary)">
        Sem dono: upload provisório ou ainda não vinculado.
      </span>
    );
  }
  const kind = ownerTarget(module, ownerType);
  return (
    <span className="space-y-1">
      <span className="block font-mono text-xs">
        {module} · {ownerType} ·{' '}
        {kind ? <EntityLink kind={kind} id={ownerId} /> : ownerId}
      </span>
      {!kind && (
        <span className="text-(--color-text-secondary) block text-xs">
          Este tipo de dono não tem página no painel.
        </span>
      )}
    </span>
  );
}
